let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("zWsTk")).then(() => parcelRequire('2MwfB'));